/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * @reducer
 * System Configuration Reducer.
 * Updates the store with the {@SystemPropertyModel} object.
 */
import { combineReducers } from 'redux';
import ReduxUtils from '../../utils/ReduxUtils';
import * as ACTIONTYPES from './actionTypes';

/**
 * Updates the system configuration details data within the Redux store.
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */
function systemConfigurationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    payload: [{
      propertyName: 'curam.environment.enable.timeout.warning.modal',
      propertyValue: 'true'
    }, {
      propertyName: 'curam.environment.timeout.warning.modal.time',
      propertyValue: '10'
    }]
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, ACTIONTYPES.SYSTEM_CONFIGURATION_FETCH_SYSTEM_PROPERTIES_ACTION_TYPES);
}

/**
 * Updates the flag in the Redux store which represents the status of fetching the
 * system configurations from it.
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */
function isFetchingSystemConfigurationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    payload: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, ACTIONTYPES.SYSTEM_CONFIGURATION_FETCH_SYSTEM_PROPERTIES_ACTION_TYPES);
}

/**
 * Updates the error object in the Redux store if there was a problem fetching the
 * system configurations from it.
 * @param {Object} state The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The new state.
 */
function systemConfigurationErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ACTIONTYPES.SYSTEM_CONFIGURATION_FETCH_SYSTEM_PROPERTIES_ACTION_TYPES);
}
var reducers = combineReducers({
  systemConfiguration: systemConfigurationReducer,
  isFetchingSystemConfiguration: isFetchingSystemConfigurationReducer,
  systemConfigurationError: systemConfigurationErrorReducer
});
export default {
  reducers: reducers
};